import { Loader2 } from "lucide-react";

/**
 * Reusable loading state component
 * @param {string} message - Loading message to display
 * @param {string} size - Size variant: 'small', 'default', 'large'
 */
export const LoadingState = ({ message = "Loading...", size = "default" }) => {
  const sizeClasses = {
    small: "py-6",
    default: "py-12",
    large: "py-20"
  };

  return (
    <div className={`flex items-center justify-center ${sizeClasses[size]}`}>
      <Loader2 className="w-6 h-6 text-blue-600 animate-spin" />
      <span className="ml-2 text-sm text-gray-600">{message}</span>
    </div>
  );
};

/**
 * Reusable error state component
 * @param {string} message - Error message to display
 */
export const ErrorState = ({ message }) => {
  return (
    <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
      <p className="text-sm text-red-600">{message}</p>
    </div>
  );
};

/**
 * Reusable empty state component
 * @param {React.Component} icon - Lucide icon component
 * @param {string} message - Empty state message
 * @param {string} actionLabel - Button label
 * @param {Function} onAction - Button click handler
 */
export const EmptyState = ({ icon: Icon, message, actionLabel, onAction }) => {
  return (
    <div className="text-center py-12">
      <Icon className="w-12 h-12 text-gray-400 mx-auto mb-3" />
      <p className="text-sm text-gray-600 mb-4">{message}</p>
      {onAction && (
        <button
          onClick={onAction}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};
